import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiFetch } from '../lib/api'

export function Register() {
  const [name, setName] = useState('')
  const [trade, setTrade] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setLoading(true)
    try {
      await apiFetch('/api/worker/register', {
        method: 'POST',
        body: JSON.stringify({ name, trade }),
      })
      navigate('/')
    } catch (err) {
      alert('Registration failed. Try again.')
    }
    setLoading(false)
  }

  return (
    <div className="page register">
      <div className="register-card">
        <div className="logo">🏨</div>
        <h1>Almost there</h1>
        <p className="subtitle">Tell us about yourself</p>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Your name</label>
            <input
              type="text"
              placeholder="John Smith"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="input"
            />
          </div>
          <div className="field">
            <label>Your trade</label>
            <select value={trade} onChange={(e) => setTrade(e.target.value)} required className="input">
              <option value="">Select your trade</option>
              <option value="electrician">Electrician</option>
              <option value="plumber">Plumber</option>
              <option value="carpenter">Carpenter</option>
              <option value="bricklayer">Bricklayer</option>
              <option value="scaffolder">Scaffolder</option>
              <option value="steel_fixer">Steel Fixer</option>
              <option value="groundworker">Groundworker</option>
              <option value="labourer">Labourer</option>
              <option value="other">Other</option>
            </select>
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Setting up...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  )
}
